// extracted by mini-css-extract-plugin
export default {"Table":"load_Table__Qh5q2"};